import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scrollContainer", "leftArrow", "rightArrow"]

  connect() {
    this.boundUpdateArrows = this.updateArrows.bind(this)
    this.scrollContainerTarget.addEventListener("scroll", this.boundUpdateArrows)
    window.addEventListener("resize", this.boundUpdateArrows)
    this.updateArrows()
  }

  disconnect() {
    this.scrollContainerTarget.removeEventListener("scroll", this.boundUpdateArrows)
    window.removeEventListener("resize", this.boundUpdateArrows)
  }

  updateArrows() {
    const el = this.scrollContainerTarget
    const scrollLeft = el.scrollLeft
    const scrollWidth = el.scrollWidth
    const clientWidth = el.clientWidth
    const hasOverflow = scrollWidth > clientWidth
    const atStart = scrollLeft <= 1
    const atEnd = scrollLeft >= scrollWidth - clientWidth - 1

    const leftHidden = !hasOverflow || atStart
    const rightHidden = !hasOverflow || atEnd

    this.leftArrowTarget.classList.toggle("is-hidden", leftHidden)
    this.rightArrowTarget.classList.toggle("is-hidden", rightHidden)
  }
}
